module.exports = __webpack_public_path__ + "public/files/img/banner.21fa13ba.png";